import type { PriceFilterTags } from '@/components/features';

export const PRICE_FILTER_MAX = 99999999 as const;

export const PRICE_RANGES: PriceFilterTags[] = [
  {
    min: 0,
    max: 500,
    isSelected: false,
  },
  {
    min: 500,
    max: 1000,
    isSelected: false,
  },
  {
    min: 1000,
    max: 2000,
    isSelected: false,
  },
  {
    min: 2000,
    max: 3000,
    isSelected: false,
  },
  {
    min: 3000,
    max: 5000,
    isSelected: false,
  },
  {
    min: 5000,
    max: 10000,
    isSelected: false,
  },
  {
    min: 10000,
    max: PRICE_FILTER_MAX,
    isSelected: false,
  },
] as const;
